export default __webpack_public_path__ + "static/media/github.f42a7e39.svg";